import { PARTNER_DEMO, readPartnerDemo } from "@/core/data/demoState";
import {
	type PartnerProfile,
	SAMPLE_PARTNER_BY_DEMO,
} from "./samplePartnerFixtures";

export type PartnerSessionDataSource = {
	loadPartnerProfile: () => PartnerProfile;
};

// Same numbering as the Beranda checklist (Lengkapi data, Kontrak, Siap stock-in).
export const ACTIVATION_STEP = {
	PartnerData: 1,
	Contract: 2,
	Activation: 3,
} as const;

export type ActivationStep =
	(typeof ACTIVATION_STEP)[keyof typeof ACTIVATION_STEP];

export const isNewPartner = (partnerProfile: PartnerProfile) =>
	partnerProfile.isAccountActive && !partnerProfile.isPortalActivated;

export const resolveActivationStep = (
	partnerProfile: PartnerProfile,
): ActivationStep => {
	if (!partnerProfile.isPartnerDataSubmitted)
		return ACTIVATION_STEP.PartnerData;
	if (!partnerProfile.isContractApproved) return ACTIVATION_STEP.Contract;
	return ACTIVATION_STEP.Activation;
};

const samplePartnerSessionDataSource: PartnerSessionDataSource = {
	loadPartnerProfile: () =>
		SAMPLE_PARTNER_BY_DEMO[readPartnerDemo() ?? PARTNER_DEMO.Active],
};

export const partnerSessionDataSource = samplePartnerSessionDataSource;
